import Component from './Component';

class BootstrapComponent extends Component{
	constructor(element, bootstrap){
		super(element);

		this.__bootstrap = bootstrap;
	}

	get bootstrap(){
		return this.__bootstrap;
	}

}


export default BootstrapComponent;
export { BootstrapComponent };